import { render, staticRenderFns } from "./IranValidityReport.vue?vue&type=template&id=13755a1f"
import script from "./IranValidityReport.vue?vue&type=script&lang=js"
export * from "./IranValidityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports